import { Workgroup } from '@g17eco/types/workgroup';

interface Props {
  workgroup: Pick<Workgroup, 'icon' | 'color'>;
  className?: string;
}

export const WorkgroupIcon = ({ workgroup, className = 'me-2' }: Props) => {
  return (
    <i
      className={`fal fa-${workgroup.icon} ${className}`}
      style={{ color: workgroup.color, minWidth: '18px' }}
    />
  );
};
